"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Label = _interopRequireDefault(require("../Label"));

var _Checkbox = _interopRequireDefault(require("../../general/Checkbox"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _Link = _interopRequireDefault(require("../../typography/Link"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'CheckboxInput');

function CheckboxInput(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onChange = _ref.onChange,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      label = _ref.label,
      labelMode = _ref.labelMode,
      hint = _ref.hint,
      error = _ref.error,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      isFullWidth = _ref.isFullWidth,
      isBulk = _ref.isBulk,
      bulkEditLabel = _ref.bulkEditLabel,
      bulkCancelLabel = _ref.bulkCancelLabel,
      onBulkEdit = _ref.onBulkEdit,
      onBulkCancel = _ref.onBulkCancel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "onChange", "id", "name", "value", "label", "labelMode", "hint", "error", "isRequired", "isReadOnly", "isFullWidth", "isBulk", "bulkEditLabel", "bulkCancelLabel", "onBulkEdit", "onBulkCancel"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      bulkEditable = _useState2[0],
      setBulkEditable = _useState2[1]; // Overrides


  var override = (0, _overrides.getOverrides)(overridesProp, CheckboxInput.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.errored, error), (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.withBulk, bulkEditable), (0, _defineProperty2.default)(_classnames, classes.withErrorBulk, error && bulkEditable), _classnames), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends2.default)({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label);
  var onClickBulkEdit = (0, _react.useCallback)(function () {
    setBulkEditable(true);
    onBulkEdit && onBulkEdit();
  }, [onBulkEdit]);
  var onClickBulkCancel = (0, _react.useCallback)(function () {
    setBulkEditable(false);
    onBulkCancel && onBulkCancel();
  }, [onBulkCancel]);
  var onCheck = (0, _react.useCallback)(function () {
    onChange && onChange(!value);
  }, [onChange, value]);
  var checkboxProps = (0, _extends2.default)({
    id: id,
    name: name,
    className: classes.checkbox,
    checked: !!value,
    onChange: onCheck,
    isDisabled: isReadOnly,
    classes: classesProp
  }, override.Checkbox);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), isBulk && !bulkEditable && /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: classes.bulkEdit,
    onClick: onClickBulkEdit
  }, bulkEditLabel), (!isBulk || isBulk && bulkEditable) && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.formControl
  }, override.formControl), /*#__PURE__*/_react.default.createElement(_Checkbox.default, checkboxProps), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.error
  }, override.error), error), bulkEditable && /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: classes.bulkCancel,
    onClick: onClickBulkCancel
  }, bulkCancelLabel)));
}

CheckboxInput.overrides = ['root', 'Checkbox', 'error', 'formControl', 'Label'];
CheckboxInput.defaultProps = {
  labelMode: 'horizontal',
  onChange: function onChange() {},
  value: '',
  isReadOnly: false,
  override: {}
};
process.env.NODE_ENV !== "production" ? CheckboxInput.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,

  /** Native input id */
  id: _propTypes.default.string,

  /** Native input name */
  name: _propTypes.default.string,
  value: _propTypes.default.any,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(CheckboxInput);

exports.default = _default;